import { render, staticRenderFns } from "./TimeAndDate.vue?vue&type=template&id=73ae33a8&"
import script from "./TimeAndDate.vue?vue&type=script&lang=ts&"
export * from "./TimeAndDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports